import { useState } from "react";
import { api } from "../api";
import { ErrorNote, errMsg } from "../ui";

export function NewWorkspace({ onCreated }: { onCreated: (id: string) => void }) {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [region, setRegion] = useState("UK");
  const [adminEmail, setAdminEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const autoSlug = (v: string) => v.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 63);

  return (
    <section className="panel">
      <h2 style={{ marginBottom: 10 }}>New client workspace</h2>
      <form className="grid" onSubmit={async (e) => {
        e.preventDefault(); setBusy(true); setError(null);
        try {
          const t = await api<{ id: string }>("POST", "/tenants", { name, slug, region, adminEmail: adminEmail || undefined });
          onCreated(t.id);
        } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
      }}>
        <label className="f">Client name<input id="nw-name" required value={name} onChange={(e) => { setName(e.target.value); setSlug(autoSlug(e.target.value)); }} /></label>
        <label className="f">Short name (used in links)<input id="nw-slug" required pattern="[a-z0-9][a-z0-9\-]{1,62}" value={slug} onChange={(e) => setSlug(e.target.value)} /></label>
        <label className="f">Data region<select id="nw-region" value={region} onChange={(e) => setRegion(e.target.value)}>
          <option value="UK">United Kingdom</option><option value="EU">European Union</option><option value="AU">Australia</option><option value="US">United States</option></select></label>
        <label className="f">Client admin email (optional)<input id="nw-admin" type="email" value={adminEmail} onChange={(e) => setAdminEmail(e.target.value)} placeholder="Invited as workspace admin" /></label>
        <div className="full"><ErrorNote error={error} /></div>
        <div className="row full"><button className="btn primary" disabled={busy}>Create workspace</button>
          <span className="muted small">The region is recorded now and used to route the client to a regional deployment later.</span></div>
      </form>
    </section>
  );
}
